import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Sensor, IconButton, Tooltip, Spinner } from '@streem/ui-react';
import { useCallback, useState, useEffect } from 'react';
import { CameraSubject } from 'streem-sdk-protobuf';
import { CameraRequestState } from '../video_frame';
import { ScreenshareRequestPrompt, ScreensharePending, ScreenshareRequestDenied, ExitScreenshare, ExitScreenshareRequestDenied, } from './screenshare_request_messages';
export const ScreenshareButton = ({ onEnterScreenshareRequest, onCancel, onExitScreenshareRequest, isScreenShareRequest, cameraSubject, cameraRequestState, }) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipMessage, setTooltipMessage] = useState();
    const [hover, setHover] = useState(false);
    const [hoverMessage, setHoverMessage] = useState();
    const pendingRequest = (cameraRequestState === CameraRequestState.PENDING &&
        isScreenShareRequest &&
        cameraSubject !== CameraSubject.CAMERA_SUBJECT_SCREEN) ||
        (cameraRequestState === CameraRequestState.PENDING &&
            !isScreenShareRequest &&
            cameraSubject === CameraSubject.CAMERA_SUBJECT_SCREEN);
    const shareScreenRequestDenied = cameraRequestState === CameraRequestState.REQUEST_DENIED && isScreenShareRequest;
    const exitScreenShareRequestDenied = cameraRequestState === CameraRequestState.REQUEST_DENIED &&
        cameraSubject === CameraSubject.CAMERA_SUBJECT_SCREEN;
    const initialRequest = cameraRequestState === CameraRequestState.INITIAL;
    useEffect(() => {
        // If a screenshare request was fulfilled, the button moves and if the expert's mouse stayed in the same spot
        // then the tooltip continued to show even when the button wasn't hovered over
        setHover(false);
    }, [cameraSubject]);
    useEffect(() => {
        // Show prompt if not currently in screenshare mode
        if (initialRequest && cameraSubject !== CameraSubject.CAMERA_SUBJECT_SCREEN) {
            setHoverMessage(_jsx(ScreenshareRequestPrompt, {}));
            // Show exit screenshare message if currently in screenshare mode
        }
        else if (initialRequest && cameraSubject === CameraSubject.CAMERA_SUBJECT_SCREEN) {
            setHoverMessage(_jsx(ExitScreenshare, {}));
        }
        else if (isScreenShareRequest && pendingRequest) {
            setHoverMessage(_jsx(ScreensharePending, {}));
        }
    }, [initialRequest, cameraSubject, isScreenShareRequest, pendingRequest]);
    useEffect(() => {
        if (shareScreenRequestDenied && cameraSubject !== CameraSubject.CAMERA_SUBJECT_SCREEN) {
            setTooltipMessage(_jsx(ScreenshareRequestDenied, { onCancel: () => {
                    setTooltipOpen(false);
                    onCancel();
                }, onRequest: () => {
                    setTooltipOpen(false);
                    onEnterScreenshareRequest();
                } }));
            setTooltipOpen(true);
        }
        else if (exitScreenShareRequestDenied &&
            cameraSubject === CameraSubject.CAMERA_SUBJECT_SCREEN) {
            setTooltipMessage(_jsx(ExitScreenshareRequestDenied, { onCancel: () => {
                    setTooltipOpen(false);
                    onCancel();
                }, onRequest: () => {
                    setTooltipOpen(false);
                    onExitScreenshareRequest();
                } }));
            setTooltipOpen(true);
        }
    }, [
        shareScreenRequestDenied,
        exitScreenShareRequestDenied,
        cameraSubject,
        onCancel,
        onEnterScreenshareRequest,
        onExitScreenshareRequest,
    ]);
    const closeTooltip = useCallback(() => {
        if (tooltipOpen) {
            setTooltipOpen(false);
            onCancel();
        }
    }, [tooltipOpen, onCancel]);
    const handleMouseEnter = useCallback(() => {
        setHover(true);
    }, []);
    const handleMouseLeave = useCallback(() => {
        setHover(false);
    }, []);
    return (_jsx(Sensor, { onClickOutside: closeTooltip, onEscape: closeTooltip, children: _jsx(Tooltip, { placement: "right", fallbackPlacements: ['left', 'top'], distance: 20, showTooltip: tooltipOpen || hover, message: tooltipOpen ? tooltipMessage : hoverMessage, borderRadius: "6px", offsetValue: cameraRequestState === CameraRequestState.PENDING && isScreenShareRequest
                ? 0
                : 15, children: pendingRequest ? (_jsx(SpinnerContainer, { onMouseOver: handleMouseEnter, onMouseOut: handleMouseLeave, children: _jsx(Spinner, { size: "40px", color: "white" }) })) : (_jsx(ScreenshareIconButton, { label: 'Request Screen Share', iconName: cameraSubject === CameraSubject.CAMERA_SUBJECT_SCREEN
                    ? 'ScreenshareCancelIcon'
                    : 'ScreenshareIcon', background: 'black', fill: 'white', onClick: cameraSubject === CameraSubject.CAMERA_SUBJECT_SCREEN
                    ? onExitScreenshareRequest
                    : onEnterScreenshareRequest, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave })) }) }));
};
const ScreenshareIconButton = styled(IconButton) `
    opacity: 0.9;

    &:active {
        opacity: 0.64;
        transform: scale(0.92);
    }
`;
const SpinnerContainer = styled.div `
    opacity: 0.9;
    margin-bottom: 8px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
`;
//# sourceMappingURL=screenshare_button.js.map